import { render, staticRenderFns } from "./ServicesForm.vue?vue&type=template&id=517b67af&scoped=true&"
import script from "./ServicesForm.vue?vue&type=script&lang=js&"
export * from "./ServicesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517b67af",
  null
  
)

export default component.exports